// Add the hardcoded JSON data
const fireLodgeAmenities = {
    "records": [
        {
            "id": "reckuhYKAaf7OxG1E",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Crib",
                "category": "Family"
            }
        },
        {
            "id": "recFbtonXmGf6T2ma",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Children's dinnerware",
                "category": "Family"
            }
        },
        {
            "id": "recMysPHbI6C1BOnp",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Pack 'n play/Travel crib",
                "category": "Family"
            }
        },
        {
            "id": "recdjJeY7IRcikR1W",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Children's books and toys, Really fun books ,Family",
                "category": "Family"
            }
        },
        {
            "id": "recsed3vg2cbhNPA3",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Baby monitor",
                "category": "Family"
            }
        },
        {
            "id": "recPraMIsI7CcKhsC",
            "createdTime": "2022-11-23T18:38:15.000Z",
            "fields": {
                "label": "55\" HDTV with Roku, DVD player",
                "category": "Entertainment"
            }
        },
        {
            "id": "rec6anSq5ZHOQFVnb",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Central air conditioning",
                "category": "Heating and cooling"
            }
        },
        {
            "id": "recLDMO1EU5Zh0oO2",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Heating",
                "category": "Heating and cooling"
            }
        },
        {
            "id": "recBBTD8SHnaLJw00",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Fire extinguisher",
                "category": "Home safety"
            }
        },
        {
            "id": "recDz9oJVq2fmFYfS",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Security cameras on property",
                "note": "We have a doorbell camera, a camera pointing at the driveway, and one at the backdoor. These are all exterior to just help us monitor the property.",
                "category": "Home safety"
            }
        },
        {
            "id": "recNdxrNXLRTIbfIr",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Carbon monoxide alarm",
                "category": "Home safety"
            }
        },
        {
            "id": "recPftlfd8mTCqoS2",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Smoke alarm",
                "category": "Home safety"
            }
        },
        {
            "id": "recbl1VixhvH8bwPG",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "First aid kit",
                "category": "Home safety"
            }
        },
        {
            "id": "recA57o7bO7fuFDGW",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Long term stays allowed",
                "note": "Allow stay for 28 days or more",
                "category": "Services"
            }
        },
        {
            "id": "recOaYwo5e30XEjZZ",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Smart lock",
                "category": "Services"
            }
        },
        {
            "id": "recVN89CFs0J1ukcf",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Self check-in",
                "category": "Services"
            }
        },
        {
            "id": "recZcIJuwtdDqxd2K",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Mountain view",
                "category": "Scenic views"
            }
        },
        {
            "id": "recZHAOUqIcI2Dk8y",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Shampoo",
                "category": "Bathroom"
            }
        },
        {
            "id": "recAfjjFaEqne1ESp",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Hair dryer",
                "category": "Bathroom"
            }
        },
        {
            "id": "recNrM3sdqeuFLR8k",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Hot water",
                "category": "Bathroom"
            }
        },
        {
            "id": "recMhnI3DsYGitQ8y",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Bed linens",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recNhCjWnMhlnfrGo",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Free washer – In unit",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recbiYRBZDyQimtWg",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Hangers",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recfp7c4H5CUwtlxT",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Extra pillows and blankets",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "rect18UlvEdHQrBbD",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Free dryer – In unit",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recuqpR0CRqsDKzbI",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Essentials",
                "note": "Towels, bed sheets, soap, and toilet paper",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "rec5uIpIpxJpFHFAx",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Wifi",
                "category": "Internet and office"
            }
        },
        {
            "id": "recRFkQZ25W1SsPq7",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Dedicated workspace",
                "category": "Internet and office"
            }
        },
        {
            "id": "recywJ4ZqPJSFU0eY",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Refrigerator",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recAeX4khu2dPiNWk",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Cooking basics",
                "note": "Pots and pans, oil, salt and pepper",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recLry4kuNrUiNl4C",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Gas stove",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "rec8xjhJ4cFAKe3QR",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Oven",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "rec85NAFPXNEHm5s9",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Microwave",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recbvkncQ8wrBYPJj",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Dishes and silverware, Bowls, chopsticks, plates, cups, etc.",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "reciKiN3vKGVbg8Ml",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Coffee maker - Pot",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recz1mCwvF8Yk7kXX",
            "createdTime": "2023-04-22T04:50:34.000Z",
            "fields": {
                "label": "Coffee maker - Super automatic",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recwBS5DlNvYIwlbV",
            "createdTime": "2023-04-22T04:50:50.000Z",
            "fields": {
                "label": "Coffee maker - Nespresso",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recnRTQOUvA0BzSp7",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Kitchen",
                "note": "Space where guests can cook their own meals",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recqvIj5NJrxx6EVl",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Dishwasher",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recy6T8JwRfztgYJr",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Private entrance",
                "category": "Location features"
            }
        },
        {
            "id": "recFBntly40K2n13j",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Ski-in/Ski-out",
                "note": "Guests can access ski lifts without driving or taking paid transportation",
                "category": "Location features"
            }
        },
        {
            "id": "recEN2nQArULCiyz1",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "EV charger",
                "note": "Guests can charge their electric vehicles on the property",
                "category": "Outdoor"
            }
        },
        {
            "id": "recEDKgw1vCBYCh11",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Private patio or balcony",
                "category": "Outdoor"
            }
        },
        {
            "id": "recVvMcZfDsiLIROX",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Free parking on premises",
                "category": "Outdoor"
            }
        },
        {
            "id": "recieyPqUOYOP05Oe",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Parking and facilities",
                "category": "Outdoor"
            }
        }
    ]
};

const hyakAmenities = {
    "records": [
        {
            "id": "reckuhYKAaf7OxG1E",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Crib",
                "category": "Family"
            }
        },
        {
            "id": "recFbtonXmGf6T2ma",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Children's dinnerware",
                "category": "Family"
            }
        },
        {
            "id": "recMysPHbI6C1BOnp",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Pack 'n play/Travel crib",
                "category": "Family"
            }
        },
        {
            "id": "recdjJeY7IRcikR1W",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Children's books and toys, Really fun books ,Family",
                "category": "Family"
            }
        },
        {
            "id": "recsed3vg2cbhNPA3",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Baby monitor",
                "category": "Family"
            }
        },
        {
            "id": "recPraMIsI7CcKhsC",
            "createdTime": "2022-11-23T18:38:15.000Z",
            "fields": {
                "label": "55\" HDTV with Roku, DVD player",
                "category": "Entertainment"
            }
        },
        {
            "id": "rec6anSq5ZHOQFVnb",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Central air conditioning",
                "category": "Heating and cooling"
            }
        },
        {
            "id": "recLDMO1EU5Zh0oO2",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Heating",
                "category": "Heating and cooling"
            }
        },
        {
            "id": "recBBTD8SHnaLJw00",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Fire extinguisher",
                "category": "Home safety"
            }
        },
        {
            "id": "recDz9oJVq2fmFYfS",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Security cameras on property",
                "note": "We have a doorbell camera, a camera pointing at the driveway, and one at the backdoor. These are all exterior to just help us monitor the property.",
                "category": "Home safety"
            }
        },
        {
            "id": "recNdxrNXLRTIbfIr",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Carbon monoxide alarm",
                "category": "Home safety"
            }
        },
        {
            "id": "recPftlfd8mTCqoS2",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Smoke alarm",
                "category": "Home safety"
            }
        },
        {
            "id": "recbl1VixhvH8bwPG",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "First aid kit",
                "category": "Home safety"
            }
        },
        {
            "id": "recA57o7bO7fuFDGW",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Long term stays allowed",
                "note": "Allow stay for 28 days or more",
                "category": "Services"
            }
        },
        {
            "id": "recOaYwo5e30XEjZZ",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Smart lock",
                "category": "Services"
            }
        },
        {
            "id": "recVN89CFs0J1ukcf",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Self check-in",
                "category": "Services"
            }
        },
        {
            "id": "recZcIJuwtdDqxd2K",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Mountain view",
                "category": "Scenic views"
            }
        },
        {
            "id": "recZHAOUqIcI2Dk8y",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Shampoo",
                "category": "Bathroom"
            }
        },
        {
            "id": "recAfjjFaEqne1ESp",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Hair dryer",
                "category": "Bathroom"
            }
        },
        {
            "id": "recNrM3sdqeuFLR8k",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Hot water",
                "category": "Bathroom"
            }
        },
        {
            "id": "recMhnI3DsYGitQ8y",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Bed linens",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recNhCjWnMhlnfrGo",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Free washer – In unit",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recbiYRBZDyQimtWg",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Hangers",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recfp7c4H5CUwtlxT",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Extra pillows and blankets",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "rect18UlvEdHQrBbD",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Free dryer – In unit",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "recuqpR0CRqsDKzbI",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Essentials",
                "note": "Towels, bed sheets, soap, and toilet paper",
                "category": "Bedroom and laundry"
            }
        },
        {
            "id": "rec5uIpIpxJpFHFAx",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Wifi",
                "category": "Internet and office"
            }
        },
        {
            "id": "recRFkQZ25W1SsPq7",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Dedicated workspace",
                "category": "Internet and office"
            }
        },
        {
            "id": "recywJ4ZqPJSFU0eY",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Refrigerator",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recAeX4khu2dPiNWk",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Cooking basics",
                "note": "Pots and pans, oil, salt and pepper",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recLry4kuNrUiNl4C",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Gas stove",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "rec8xjhJ4cFAKe3QR",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Oven",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "rec85NAFPXNEHm5s9",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Microwave",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recbvkncQ8wrBYPJj",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Dishes and silverware, Bowls, chopsticks, plates, cups, etc.",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "reciKiN3vKGVbg8Ml",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Coffee maker - Pot",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recz1mCwvF8Yk7kXX",
            "createdTime": "2023-04-22T04:50:34.000Z",
            "fields": {
                "label": "Coffee maker - Super automatic",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recwBS5DlNvYIwlbV",
            "createdTime": "2023-04-22T04:50:50.000Z",
            "fields": {
                "label": "Coffee maker - Nespresso",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recnRTQOUvA0BzSp7",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Kitchen",
                "note": "Space where guests can cook their own meals",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recqvIj5NJrxx6EVl",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Dishwasher",
                "category": "Kitchen and dining"
            }
        },
        {
            "id": "recy6T8JwRfztgYJr",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Private entrance",
                "category": "Location features"
            }
        },
        {
            "id": "recFBntly40K2n13j",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Ski-in/Ski-out",
                "note": "Guests can access ski lifts without driving or taking paid transportation",
                "category": "Location features"
            }
        },
        {
            "id": "recEN2nQArULCiyz1",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "EV charger",
                "note": "Guests can charge their electric vehicles on the property",
                "category": "Outdoor"
            }
        },
        {
            "id": "recEDKgw1vCBYCh11",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Private patio or balcony",
                "category": "Outdoor"
            }
        },
        {
            "id": "recVvMcZfDsiLIROX",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Free parking on premises",
                "category": "Outdoor"
            }
        },
        {
            "id": "recieyPqUOYOP05Oe",
            "createdTime": "2022-11-23T18:36:52.000Z",
            "fields": {
                "label": "Parking and facilities",
                "category": "Outdoor"
            }
        }
    ]
};

// Mock tableByID function
export function tableByID(tableID) {
  console.warn("Airtable tableByID called with mock data for table:", tableID);
  const amenities = CURRENT_BRAND_SLUG === 'hyak' ? hyakAmenities : fireLodgeAmenities;
  return {
    select: () => {
      console.warn("Airtable select called on mock table:", tableID);
      return {
        firstPage: () => Promise.resolve(amenities.records)
      };
    }
  };
}

export function minifyItems(records) {
  return records.map((record) => getMinifiedItem(record));
}

export function getMinifiedItem(record) {
  return {
    id: record.id,
    ...record.fields,
  };
}

// Export a mock table object that mimics the Airtable select method
export const table = {
  select: () => {
    const amenities = CURRENT_BRAND_SLUG === 'hyak' ? hyakAmenities : fireLodgeAmenities;
    console.log(`Fetching mock Airtable data for ${CURRENT_BRAND_SLUG}`);
    return {
      firstPage: () => Promise.resolve(amenities.records)
    };
  }
};
